import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import GalleryGridFront from './layout/portfolio/GalleryGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import WarpLarge from './layout/warp/WarpLarge';
import Paragraph from './layout/Paragraph';
import ProcessThreeSteps from './layout/Process';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import VideoMockup from './layout/portfolio/VideoMockup';
import PenIcon from './asset/PenIcon';
import NextUp from './layout/warp/NextUp';

// Image assets
import Front from './img/sportsmate/SM_Cover@2x.jpg';
import SMCover from './img/sportsmate/SM_product@2x.png';
import product_2 from './img/sportsmate/closed-up-epl@2x.png';
import product_3 from './img/sportsmate/closed-up-basketball@2x.png';
import androidWidget_1 from './img/sportsmate/androidWidget@2x.png';
import fixture from './img/sportsmate/Fixture_1@2x.png';
import finalGrid_Vid from './img/sportsmate/SMBracketNBA_1080.mp4';
import finalGrid_Confetti from './img/sportsmate/SMBracket_1@2x.png';
import finalGrid_Element from './img/sportsmate/SMBracket_element@2x.png';

import sportmateComp_2 from './img/sportsmate/SM_ComponentExample_1@2x.jpg';
import sportmateComp_3 from './img/sportsmate/SM_ComponentExample_2@2x.jpg';
import worldSoccer_1 from './img/sportsmate/SM_worldSoccer_1@2x.png';
import worldSoccer_2 from './img/sportsmate/SM_WC_Onboarding@2x.png';
import worldSoccer_3 from './img/sportsmate/SM_WC_End@2x.png';


// Summary
const companyInfo = {
  title: "Home of your favourite sports apps",
  name: "Sportsmate mobile",
  themeColor: "#14212F",
  themeTextColor: "white",
  frontImage: Front,
  role: "Lead product designer",
  fields: "Product design (UX/UI)",
  time: "Apr 2017 – Jun 2018",
  description: "The featured app you will see on AppStore during the sports season! As a lead designer, I've worked on rich features to help fans to follow the games anytime. Podcasts, favourite, widgets and final bracket are the key features I've introduced to the app."
}

// responsibility list
const list = ['Executed at every stage of design lifecycle.', 'Used prototyping as mean to convey iterative and experimental ideas.', 'Used and evolved design system in order to manage and scale an experience to multiple sports.','Worked cross-functionally with engineering, marketing, and content teams to represent the design and user experience of features.'];


// About sportsmate
const SMproduct = {
  summary: "About the company",
  titleIcon: PenIcon,
  title: "Who are Sportsmate?",
  paragraph: "Sportsmate Mobile is a start-up founded in 2009. As an early starter for mobile app, they created and established the mobile UX pattern for many sports apps nowadays. The suite of SM Live apps provides news, real-time stats, rank, and players information – Loved by millions of users around the world.",
  themeColor: '#14212F',
  textColor: '#ffffff',
}

const challenge = {
  summary: "White labelling",
  heading: "The biggest challenge at Sportsmate was that our small team has to create eight different sport experiences.",
  paragraph: "Each sport is unique, but they can be also similar in an aspect of the matches, top players, and the road to be the champion. Because the Sportsmate team was very small, it was a crucial to work efficiently by unifying all different sports under one design and experience – without being generic. \n\nEvery feature we were working on was tested with eight different scenarios from each sport's rules, in order to verify the scalability. I've learnt a lot from this process. Stepping back to think about the scalability became a part of my design workflow even before the Design System became the norm years later.",
}

const funpart = {
  summary: "custom interface",
  heading: "When you thoroughly understand the foundation, it can take you to the zone where you can completely think outside of the box.",
  paragraph: "Based on the deep understanding of how the platform conventions were created, we were constantly evolving to create something unique with our apps. This mindset gave me a chance to apply the interesting concepts I've been discovering through generative art. ",
  paragraph_2:"\n\nThe perfect example of this is when we made the Favourite feature. Just thought it could look cool, I made a prototype for a micro interaction - The team logo is popping out from the plus icon then plunges into the Favourite tab.",
  paragraph_3:"The appetite for creating something new helped us experiment and build lots of unique ideas. This sprit still inspires me to understand the convention thoroughly then eventually challenge it – rather than use it to only limit the creativity.",
  sidenote: "These kind of ideas usually make the developers shiver 🤯 ...but not at sportsmate!"
}


const featuresIworked = {
  summary:"Creating new experience",
  heading: "Compared to adding a new feature to a new app, there were lots to consider when you work on the product with nine years of mature user experience.",
  paragraph: "Our users have formed a mental model from using the app over the years. It was the proudest thing, but also an obstacle to overcome. Especially the core features, such as navigation and the fixture, were sensitive to update. \n\nCreating a new experience always came along with a question. Should we keep it? Should we add something? or Should we completely change it? And the answer wasn't always straight forward. There were lots of lessons from both mistakes and successes I made.",
  dotPoints: {
    description_1: "A new scoreboard created for the championship tournament.",
    description_2: "FIFA World Cup, Olympics, or Asian Cup... one app for your national team. ",
    description_3: "A new era of GUI design started. Bolder, colourful, and spacious."
  }
}


const finalGrid = {
  image_1: finalGrid_Vid,
  image_2: finalGrid_Confetti,
  image_3: finalGrid_Element,
  summary:"Final grid",
  title: "Designed for the championship, optimised to see all the rounds at once.",
  paragraph: "This was probably the most mathematically calculated layout I've ever worked on. Each sport has a different rule for the first round - Round of 16, Wild Cards, and aggregated scores! Then the total number of teams reduces by half. Once the champion is announced, the rest is fun. We congratulate them with confetti! 🎉\n\nLots of time was spent on defining what should be different between the normal fixture and the final grid. Without defining what that is, the two screens would feel like a duplicate. To distinguish from 1-to-1 match layout, I defined the intent of the final grid as to implicate everything on 'one screen' in a minimalistic way.",
  themeColor:"#252731",
  textColor:"#ffffff"
}


const WorldSoccer = {
  image_1: worldSoccer_3,
  image_2: worldSoccer_2,
  image_3: worldSoccer_1,
  summary:"World Soccer App",
  title: "Created for seasonal international soccer events.",
  paragraph: "Our core users are the people who watch sports leagues on a daily basis. What about the casual audience who wants to support their national team during the international soccer events – such as the FIFA World Cup? Sportsmate's World Soccer App came out to target the casual soccer fans. \n\nThanks to the modular design system, it didn't take a long time to build the World Soccer app. Instead, the UX effort was focused on creating a seamless flow to introduce the new app in the early stage of the event, and then transfer the user to other apps when the event finishes.",
}

const DesignUpdate = {
  image_2: androidWidget_1,
  image_3: fixture,
  summary:"iOS/Android design refresh",
  title: "I realised a redesign is a test for two subjects: User value and productivity.",
  paragraph: "Every designer's dream is to redesign, but often it's at the bottom of the user's wishlist. The design direction is often initiated by the release of a new OS, not by their needs. To overcome this, I tried to adapt feedback and desires from the users to update the interface.\n\nOn another subject, the nights I spent learning to code finally shined! Being a cross-functional designer, I checked and updated the detail to speed up productivity. I was even re-designed the Android widgets by myself and which was approved by the developer. (Yay!)",
  themeColor: '#732A55',
  textColor: '#ffffff',
}


const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/sportsmate",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + companyInfo.front
}

class PortfolioSportsmate extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>

        <Navigation />
        {/*Front page*/}
        <GalleryGridFront first={Front} title={companyInfo.title} themeColor={companyInfo.themeColor}/>
        {/*Position summary*/}
        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          time={companyInfo.time}
          description={companyInfo.description}
          dotPoints={list}/>

        {/*----- Who are sportsmate ------*/}
        <ImageGridx1
          first={SMCover}
          innerDescription={<BriefIcon summary={SMproduct.summary} titleIcon={<PenIcon color={SMproduct.textColor}/>}
          title={SMproduct.title}
          caption={SMproduct.title}
          paragraph={SMproduct.paragraph} textColor={SMproduct.textColor}/>}themeColor={SMproduct.themeColor}
          showTriangle
        />

        {/*----- the challenge ------*/}
        <Paragraph
          titleText={challenge.summary}
          heading={challenge.heading}
          paragraph={challenge.paragraph}
        />

        <ImageGridx1
          first={sportmateComp_2}
          themeColor="#E7EEF6"
          caption="An example of how the player profile screen is made. It's like designing a blueprint where the data goes in it." />

        <GalleryGridx1
          first={sportmateComp_3}
          themeColor="#CCE0D6"
          caption="To create the ultimate modular system, I need to see them as a whole picture. Because they need to be consistent, but also abundant."/>

        {/*----- Fun animation ------*/}
        <Paragraph
          titleText={funpart.summary}
          heading={funpart.heading}
          paragraph={funpart.paragraph + funpart.paragraph_2}/>

        <ImageGridx2
          first={"https://cdn.dribbble.com/users/124935/screenshots/4210486/fun-animation_1x.gif"}
          second={"https://cdn.dribbble.com/users/124935/screenshots/3591128/onestream-animation.gif"}
          caption={funpart.sidenote}/>

        <Paragraph
          paragraph={funpart.paragraph_3}/>

        {/*----- New feeatures and outcomes  ------*/}
        <GalleryGridx2
          first={product_2}
          second={product_3}
          themeColor="#CCE0D6"/>

        <Paragraph
          titleText={featuresIworked.summary}
          heading={featuresIworked.heading}
          paragraph={featuresIworked.paragraph}/>

        <ProcessThreeSteps
          heading="Highlights"
          first="Final grid"
          firstDetail={featuresIworked.dotPoints.description_1}
          second="World Soccer App"
          secondDetail={featuresIworked.dotPoints.description_2}
          third="iOS/Android design refresh"
          thirdDetail={featuresIworked.dotPoints.description_3}
          />
        {/*----- Final grid ------*/}
        <ImageGridx2
          first={finalGrid.image_2}
          second={finalGrid.image_3}
          innerDescription={<BriefIcon summary={finalGrid.summary}
          title={finalGrid.title}
          caption={finalGrid.title}
          paragraph={finalGrid.paragraph} textColor={finalGrid.textColor}/>}themeColor={finalGrid.themeColor}
          extra={<div className="col col-1"><VideoMockup video={finalGrid.image_1}/></div>}
          showTriangle
        />
        {/*----- World Soccer app ------*/}
        <GalleryGridx1
          first={WorldSoccer.image_3}
          themeColor="#CCE0D6"/>
        <ImageGridx2
          first={WorldSoccer.image_2}
          second={WorldSoccer.image_1}
          innerDescription={<BriefIcon summary={WorldSoccer.summary}
          title={WorldSoccer.title}
          paragraph={WorldSoccer.paragraph} textColor={WorldSoccer.textColor}/>}themeColor={WorldSoccer.themeColor}
        />
      {/*----- Design update ------*/}
        <ImageGridx2
          first={DesignUpdate.image_3}
          second={DesignUpdate.image_2}
          innerDescription={<BriefIcon summary={DesignUpdate.summary}
          title={DesignUpdate.title}
          caption={DesignUpdate.title}
          paragraph={DesignUpdate.paragraph} textColor={DesignUpdate.textColor}/>}themeColor={DesignUpdate.themeColor}
          showTriangle
        />
        <NextUp
          previous="Itty Bitty Apps"
          previousURL="/ittybittyapps"
          next="Medibank"
          nextURL="/medibank"
        />
        <WarpLarge />
        <Footer/>
      </div>
    );
  }
}

export default PortfolioSportsmate;



// WEBPACK FOOTER //
// ./src/PortfolioSportsmate.js